import { useRef,useCallback, useState, useEffect, } from 'react';
import ReactQuill, { Quill } from "react-quill"; // ES6
import "react-quill/dist/quill.snow.css";
import "./textEditor.css";
import axios from 'axios';
import Toolbar from './TextEditorToolbar';
import {toast} from 'react-toastify';
import ImageBlot from './ImageBlot';
import  clsx from 'clsx';

function TextEditor({
  label,
  placeholder,
  className,
  value,
  onChange,
  defaultValue,
  variant = "user",
  quillClasses
}) {
  const videoInputRef = useRef(null);
  const imageInputRef = useRef(null);
  const quillRef = useRef(null);


  Quill.register(ImageBlot);



  const imageInsertHandler = useCallback(() => {
    imageInputRef.current.click();
  }, []);

  const insertVideoHandler = useCallback(() => {
    videoInputRef.current.click();
  }, []);

  const saveImage = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const quill = quillRef.current.getEditor();
      quill.focus();
      let range = quill.getSelection();
      const position = range?.index || 0;

      const file = e?.target?.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "upload_preset",
        process.env.REACT_APP_CLOUDINARY_UNSIGNED_PRESET
      );
      const response = await axios.post(
        process.env.REACT_APP_CLOUDINARY_UNSIGNED_URL,
        formData
      );
      const { secure_url, public_id, original_filename } = response?.data;
      quill.insertEmbed(position, "image", {
        src: secure_url,
        alt: original_filename,
        public_id,
      });
      quill.setSelection(position + 1);
    } catch (error) {
      toast.error("could not upload image");
    }
  }, []);


  const handleInputChange = (html) => {
    onChange(html)
  };

  const modules = {
    // syntax: true,
    toolbar: {
      container: "#toolbar",
      handlers: {
        insertImage: imageInsertHandler,
        insertVideo: insertVideoHandler,
      },
    },
  };

  return (
    <div>
      <span className="leading-6 font-semibold text-sm text-boudoir tracking-wider mb-2 inline-block">
        {label}
      </span>
      <div className={
        clsx({
          "quill__wrapper w-full": true,
          quillClasses,
        })
      }>
        <Toolbar variant={variant} />
        <ReactQuill
          ref={(el) => {
            quillRef.current = el;
          }}
          theme={"snow"}
          className={className}
          placeholder={placeholder}
          modules={modules}
          defaultValue={defaultValue}
          value={value}
          onChange={handleInputChange}
        />
        <input
          accept="video/*"
          ref={videoInputRef}
          type="file"
          className="hidden"
        />
        <input
          accept="image/*"
          ref={imageInputRef}
          type="file"
          className="hidden"
          onChange={saveImage}
        />
      </div>
    </div>
  );
};
TextEditor.defaultProps = {
  onChange: () => {},
  value: '',
};
export default TextEditor;
